import { UserRole } from '@snap-types/models/enums';
import type { UserWithSettings } from '@snap-types/models/user';

// Divide by order of magnitude for readability
const USER_ROLE_HIERARCHY: Record<UserRole, number> = {
  [UserRole.READ_ONLY]: 1,
  [UserRole.ASSISTANT]: 10,
  [UserRole.RESTRICTED]: 100,
  [UserRole.ESTIMATOR]: 1_000,
  [UserRole.SITE_ADMIN]: 10_000,
  [UserRole.SUPERADMIN]: 100_000,
};

export const hasMinimumRole = ({
  minimumRole,
  user,
}: {
  minimumRole: UserRole;
  user: Pick<UserWithSettings, 'role'>;
}): boolean => {
  const userRoleIndex = USER_ROLE_HIERARCHY[user.role];
  const minimumRoleIndex = USER_ROLE_HIERARCHY[minimumRole];

  if (userRoleIndex === undefined || minimumRoleIndex === undefined) {
    // This can only happen if the typing is violated, but better safe than sorry
    throw new Error(
      `Unknown user role (${user.role}) or minimum role (${minimumRole}).`,
    );
  }
  return userRoleIndex >= minimumRoleIndex;
};

export function userCanEditQuoteLine(
  user: Pick<UserWithSettings, 'role'>,
): boolean {
  return hasMinimumRole({ minimumRole: UserRole.RESTRICTED, user });
}

export function userCanEditQuote(
  user: Pick<UserWithSettings, 'role'>,
): boolean {
  return hasMinimumRole({ minimumRole: UserRole.ASSISTANT, user });
}
